import { render, staticRenderFns } from "./answeredPreview.vue?vue&type=template&id=5112ca21&scoped=true&"
import script from "./answeredPreview.vue?vue&type=script&lang=js&"
export * from "./answeredPreview.vue?vue&type=script&lang=js&"
import style0 from "./answeredPreview.vue?vue&type=style&index=0&id=5112ca21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112ca21",
  null
  
)

export default component.exports